export default __webpack_public_path__ + "static/media/outline_add_white_24dp 1.cbdd604c.svg";